import gql from 'graphql-tag';
import { ContentDocumentFields } from '../construct/construct.queries';

export const ARTICLE_PAGE = gql`
	query ArticleDocument($articleId: Int!) {
		articleDocument(articleId: $articleId) {
			...ContentDocumentFields
		}
	}
	${ContentDocumentFields}
`;
